//import Libraries
import React from 'react'

//import Components

//import Styles
import './AddToCartButton.css';

const addToCartButton = (props) => {
    const {onAddToCart, id, quantity} = props;
    return (
        <div>
            <button onClick={() => onAddToCart(id, quantity)} >Add To Cart</button>
        </div>
    );
}

export default addToCartButton;



// WEBPACK FOOTER //
// ./src/pages/Store/Props/AddToCartButton.js